/* eslint-disable no-empty-pattern */
import axios from "~axios"
import ProvidedExpertRoutes from "../../modules/Expert/data/provided-expert-routes"

// Promise to prevent duplicate menu data requests
let menuDataPromise = null

export default {
    namespaced: true,
    state: {
        currentUser: {
            name: "",
            avatar: "",
            courseCount: 0,
            cabinets: [],
            default_cabinet: {},
            subscriptions: 0,
            products: 0
        },
        courses: [],
        cabinet_link: null,
        cabinets: [],
        // defaultCabinet: {},
        //get course viewers for experts
        // courseViewers: [],
        coursesLoad: false,
        // breadCrLoader: false,
        isProd: true,
        isOpenOnProd: true,
        cabinetAccesses: null,
        activeAlerts: [],
        menu: {},
        rewardsData: [],
        rewardsMetaData: {},
        rewardsStatus: {
            sum_points: 0,
            sum_deducted_points: 0,
            sum_accrued_points: 0
        },
        loginHistoryData: [],
        loginHistoryMetaData: {},
        currentSessionInfo: {},
        linkedServices: [],
        fields: [],
        orderList: [],
        menuData: null
    },
    getters: {
        currentUser(state) {
            return state.currentUser
        },

        isAnimalAvatar(state) {
            return (
                state.currentUser && state.currentUser.avatar_url && state.currentUser.avatar_url.includes("/animals")
            )
        },

        getRewardsData(state) {
            return state.rewardsData
        },
        getRewardsMetaData(state) {
            return state.rewardsMetaData
        },
        getLoginHistoryData(state) {
            return state.loginHistoryData
        },
        getLoginHistoryMetaData(state) {
            return state.loginHistoryMetaData
        },
        getRewardsStatus(state) {
            return state.rewardsStatus
        },
        courses(state) {
            return state.courses
        },
        cabinets(state) {
            return state.cabinets
        },
        activeCabinet(state) {
            return state.cabinets.find(c => c.id === window.active_cabinet_id)
        },
        coursesLoad(state) {
            return state.coursesLoad
        },
        cabinetAccesses(state) {
            return state.cabinetAccesses
        },
        activeAlerts(state) {
            return state.activeAlerts
        },
        expertMenu(state) {
            return state.menu
        },
        getLinkedServices(state) {
            return state.linkedServices
        },
        getCurrentSessionInfo(state) {
            return state.currentSessionInfo
        },
        cabinetLink(state) {
            return state.cabinet_link
        },
        getUserFields(state) {
            return state.fields
        },
        getMenuData(state) {
            return state.menuData
        },
        getStudentsCabinets(state) {
            return state.menuData?.student_cabinets
        },
        getExpertCabinets(state) {
            return state.menuData?.expert_cabinets
        },
        getCurrentCabinet(state) {
            return state.menuData.current_student_cabinet
        },
        getBrandingBlockStatus(state) {
            return state.menuData?.is_branding_enabled
        },
        getOrderList(state) {
            return state.orderList
        }

        // defaultCabinet(state) {
        //     return state.defaultCabinet
        // }
    },
    mutations: {
        setProductionMode(state, newValue) {
            state.isProd = newValue
        },
        SET_CURRENT_USER(state, newValue) {
            state.currentUser = newValue
        },
        SET_COURSES(state, newValue) {
            state.courses = newValue
        },
        TOGGLE_LOADING(state, newValue) {
            state.coursesLoad = newValue
        },
        SET_CABINETS(state, newValue) {
            state.cabinets = newValue
        },
        CHANGE_CURRENT_CABINET(state, personalSettings) {
            state.cabinets.forEach(cabinet => {
                if (cabinet.is_current && cabinet["personal_settings"]) {
                    cabinet["personal_settings"] = personalSettings
                }
            })
        },
        SET_CABINET_ACCESSES(state, newValue) {
            state.cabinetAccesses = newValue
        },
        SET_ALERTS(state, payload) {
            state.activeAlerts = payload
        },
        SET_MENU(state, payload) {
            state.menu = payload
        },
        SET_CABINET_LINK(state, payload) {
            state.cabinet_link = payload
        },
        SET_PURCHASE_HISTORY(state, payload) {
            state.purchaseHistoryData = payload
        },
        SET_PURCHASE_HISTORY_META(state, payload) {
            Object.assign(state.purchaseHistoryMetaData, payload)
        },
        SET_LOGIN_HISTORY(state, payload) {
            state.loginHistoryData = payload
        },
        SET_LOGIN_HISTORY_META(state, payload) {
            Object.assign(state.loginHistoryMetaData, payload)
        },

        SET_REWARDS_DATA(state, payload) {
            state.rewardsData = payload
        },
        SET_REWARDS_META(state, payload) {
            Object.assign(state.rewardsMetaData, payload)
        },
        SET_REWARDS_STATUS(state, payload) {
            Object.assign(state.rewardsStatus, payload)
        },
        SET_CURRENT_SESSION_INFO(state, payload) {
            Object.assign(state.currentSessionInfo, payload)
        },
        SET_LINKED_SERVICES(state, payload) {
            state.linkedServices = payload
        },
        UPDATE_USER_EMAIL(state, payload) {
            state.currentUser.email = payload
        },
        SET_USER_FIELDS(state, payload) {
            state.fields = payload
        },
        SET_MENU_DATA(state, payload) {
            state.menuData = payload
        },
        UPDATE_AUTO_TIMEZONE(state) {
            state.currentUser.is_auto_timezone = !state.currentUser.is_auto_timezone
        },
        SET_ORDER_LIST(state, data) {
            state.orderList = data
        }
        // SET_DEFAULT_CABINET(state, newValue) {
        //     state.defaultCabinet = newValue
        // }
    },
    actions: {
        //user
        fetchUser({ commit }) {
            if (window.hasOwnProperty("user")) {
                const user = window.user
                commit("SET_CURRENT_USER", user)
                return user
            }
            return axios.get("/user").then(response => {
                const user = response.data.data
                commit("SET_CURRENT_USER", user)
                return user
            })
        },
        fetchExtendedUser() {
            return new Promise((resolve, reject) => {
                axios
                    .get("/user")
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        updateUser({ commit }, { payload, id }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/users/${id}`, payload)
                    .then(response => {
                        commit("SET_CURRENT_USER", response.data.data)
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        updateUserField({ commit }, data) {
            let endPoint = data.isDefault ? `students/fields` : "students/fields/default"

            return new Promise((resolve, reject) => {
                axios
                    .put(endPoint, data.payload)
                    .then(response => {
                        commit("SET_CURRENT_USER", response.data.data)
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },

        updateUserAutoTimeZone({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .put("students/timezone/auto")
                    .then(response => {
                        commit("UPDATE_AUTO_TIMEZONE")
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        updateUserAuthType({}, { userId, auth_type }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`users/${userId}`, { auth_type })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        fetchUserFields({ commit }, type) {
            let endPoint = type ? `/contact-tabs-fields/users/fields/all` : "contact-fields/student/default"

            return new Promise((resolve, reject) => {
                axios
                    .get(endPoint)
                    .then(response => {
                        commit("SET_USER_FIELDS", response.data.data)
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },

        //email
        checkEmail({}, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/personal/contacts/update/codes/send`, payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        checkEmailCode({}, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/personal/contacts/code/check`, payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        updateUserEmail({ commit }, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/personal/contacts/update`, payload)
                    .then(response => {
                        commit("UPDATE_USER_EMAIL", payload.email)
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },

        //pass && auth
        restorePass({}, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/auth/restore`, payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        confirmRestorePass({}, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/auth/restore/confirm`, payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        setNewPass({}, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/auth/restore/set-password`, payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        checkCurrentPass({}, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`user/password/validate`, payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        requestConfirmationCode({}, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`user/password`, payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        confirmPasswordChange({}, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`user/password/confirm`, payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        fetchLinkedServices({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/user/auth-services")
                    .then(response => {
                        commit("SET_LINKED_SERVICES", response.data.data)
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        //sessions data
        fetchCurrentSession({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/user/login-history/current")
                    .then(response => {
                        commit("SET_CURRENT_SESSION_INFO", response.data.data)
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        fetchLoginData({ commit }, query) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/user/login-history", { params: query })
                    .then(response => {
                        commit("SET_LOGIN_HISTORY", response.data.data)
                        commit("SET_LOGIN_HISTORY_META", response.data.meta)
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },

        //products data
        fetchRewardsData({ commit }, query) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/user/flows/rewards", { params: query })
                    .then(response => {
                        commit("SET_REWARDS_DATA", response.data.data)
                        commit("SET_REWARDS_META", response.data.meta)
                        let status = {
                            sum_points: response.data.sum_points,
                            sum_deducted_points: response.data.sum_deducted_points,
                            sum_accrued_points: response.data.sum_accrued_points
                        }
                        commit("SET_REWARDS_STATUS", status)
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        fetchProducts({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/user/products")
                    .then(response => {
                        commit("SET_COURSES", response.data.data)

                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        async fetchCourse({ commit }, payload = {}) {
            commit("TOGGLE_LOADING", true)
            try {
                const response = await axios.get("/user/products", { params: payload })
                const courses = response.data.data
                commit("SET_COURSES", courses)
                commit("SET_CABINET_LINK", response.data.cabinet_link)
                return response.data
            } catch (e) {
                throw Error(e)
            } finally {
                commit("TOGGLE_LOADING", false)
            }
            // return axios.get("/courses/user").then((response) => {
            //     const courses = response.data.data
            //     commit("SET_COURSES", courses)
            //     return courses
            // })
        },

        //other
        fetchPurchaseHistory({ commit }, query) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/user/purchases", { params: query })
                    .then(response => {
                        commit("SET_PURCHASE_HISTORY", response.data.data)
                        commit("SET_PURCHASE_HISTORY_META", response.data.meta)
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        async fetchIsProductionMode({ commit }) {
            if (window.hasOwnProperty("is_prod")) {
                const isProd = window.is_prod
                commit("setProductionMode", isProd)
                return isProd
            }
            await axios.get("/is_prod").then(response => {
                let value = response.data.status
                commit("setProductionMode", value)
                if (!sessionStorage.getItem("isProd")) sessionStorage.setItem("isProd", value)
            })
        },
        fetchCabinets({ commit }) {
            if (window.hasOwnProperty("cabinets")) {
                const cabinets = window.cabinets
                commit("SET_CABINETS", cabinets)
                return cabinets
            }
            return axios.get("/cabinets").then(response => {
                const cabinets = response.data.data
                commit("SET_CABINETS", cabinets)
                return cabinets
            })
        },
        fetchExpertMenu({ commit }) {
            return new Promise(resolve => {
                commit("SET_MENU", ProvidedExpertRoutes)
                resolve()
            })
        },
        fetchCabinetAccesses({ commit }) {
            return axios.get("/cabinet/users/permissions").then(response => {
                let cabinetAccesses = response.data.data

                if (!Array.isArray(cabinetAccesses)) {
                    let data = []
                    for (let type in cabinetAccesses) {
                        data.push(cabinetAccesses[type])
                    }

                    cabinetAccesses = data
                }

                commit("SET_CABINET_ACCESSES", cabinetAccesses)
                return cabinetAccesses
            })
        },
        fetchActiveAlerts({ commit }) {
            return axios
                .get("/alerts")
                .then(res => commit("SET_ALERTS", res.data.data))
                .catch(e => console.log("fetching alerts error:", e))
        },

        //user domains & manu data
        fetchMenuData({ commit, state }, params) {
            // If data is already loaded, return immediately
            if (state.menuData !== null) {
                return Promise.resolve()
            }

            // If request is already in progress, return existing promise
            if (menuDataPromise) {
                return menuDataPromise
            }

            // Create new promise for the request
            menuDataPromise = axios
                .get("/profile/menu", { params })
                .then(res => {
                    commit("SET_MENU_DATA", res.data.data)
                    if (params?.is_expert && res.data.data.expert_subscription_data?.subscription) {
                        commit("tariff/SET_CURRENT_SUBSCRIPTION", res.data.data.expert_subscription_data.subscription, {
                            root: true
                        })
                    }
                    menuDataPromise = null // Reset promise after completion
                })
                .catch(e => {
                    console.log("fetching menu data error:", e)
                    menuDataPromise = null // Reset promise on error
                    throw e
                })

            return menuDataPromise
        },
        fetchUserOrdersList({ commit }) {
            return axios
                .get("orders/payments/pending")
                .then(res => {
                    commit("SET_ORDER_LIST", res.data)
                })
                .catch(e => console.log("fetching order list error:", e))
        }
    }
}
